import React from 'react';
import { Link } from 'react-router-dom';
import './CustomCake.css';

const CustomCake = () => (
  <div className="custom-cake">
    <h1>Custom Cakes</h1>
    <p>
      Make your moments unforgettable with our custom-designed cakes. Choose the flavor, size, theme, and message — we’ll take care of the rest.
    </p>
    <div className="options">
      <div>Birthday Cakes</div>
      <div>Anniversary Cakes</div>
      <div>Wedding Cakes</div>
      <div>Kids Theme Cakes</div>
      <div>Corporate Cakes</div>
    </div>
    <Link to="/contact" className="btn">contact</Link>
  </div>
);

export default CustomCake;
